import { render, staticRenderFns } from "./ResolveConflictErnAction.vue?vue&type=template&id=35c2b190&scoped=true&"
import script from "./ResolveConflictErnAction.vue?vue&type=script&lang=js&"
export * from "./ResolveConflictErnAction.vue?vue&type=script&lang=js&"
import style0 from "./ResolveConflictErnAction.vue?vue&type=style&index=0&id=35c2b190&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2b190",
  null
  
)

export default component.exports